import { theme } from '@factorialco/deprecated-design-system'
import { Building, Coffee, Comment, Pin } from '@factorialco/f0-react/icons/app'
import { ShiftManagementShiftCalendarEventFragment } from 'generated/resources/graphql'
import { compact } from 'lodash'

import { CalendarEventNormalizer } from 'modules/core/components/CalendarEventList/types'
import {
  dateBackendDateTimeToUITimeRange,
  stringToDate,
  timeToStringWithTimezone,
} from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const managementShiftTitle = (shift: ShiftManagementShiftCalendarEventFragment) => {
  const { templateWeek } = shift.shiftConfiguration || {}
  const { template, name: templateWeekName } = templateWeek || {}
  const templateName = template?.name

  const templateTitle = templateName ? [templateName, templateWeekName].join(' - ') : ''
  return shift.defaultShift ? shift.defaultShift.title : templateTitle
}

export const shiftCalendarEventNormalizer: CalendarEventNormalizer<
  ShiftManagementShiftCalendarEventFragment
> = (item: ShiftManagementShiftCalendarEventFragment) => {
  const description = dateBackendDateTimeToUITimeRange(item.localStartAt, item.localEndAt)

  const date = stringToDate(item.localStartAt, 'backend_datetime').toDate()

  const breaks = item.plannedbreaksConnection.nodes

  // Obtain these from query
  // const workAreaName = item.locationsWorkAreaId
  // const locationName = item.locationId

  return {
    title: managementShiftTitle(item),
    label: item.extraHours ? i18n.t('shift_management.overtime_tag') : undefined,
    description,
    isPending: false,
    color: item.color ? `#${item.color}` : theme.colors.grey400,
    toDate: date,
    leftTags: compact([
      !!breaks.length && {
        icon: Coffee,
        label: i18n.t('shift_management.actions_sidepanel.tooltip.breaks'),
        description: compact(
          breaks.map((shiftBreak) => {
            if (!shiftBreak.startAt || !shiftBreak.endAt) {
              if (shiftBreak.duration) {
                return shiftBreak.duration
              }

              return
            }

            const startAt = timeToStringWithTimezone(shiftBreak.startAt, item.timezone)
            const endAt = timeToStringWithTimezone(shiftBreak.endAt, item.timezone)
            return `${startAt} - ${endAt}`
          })
        ).join('\n'),
      },
      item.notes && {
        icon: Comment,
        label: i18n.t('shift_management.actions_sidepanel.tooltip.notes'),
        description: item.notes,
      },
      item.locationsWorkAreaId && {
        icon: Building,
        // ...(workAreaName && {
        //   label: i18n.t('shift_management.actions_sidepanel.tooltip.work_area'),
        //   description: workAreaName,
        // }),
      },
      item.locationId && {
        icon: Pin,
        // ...(locationName && {
        //   label: i18n.t('shift_management.actions_sidepanel.tooltip.workplace'),
        //   description: locationName,
        // }),
      },
    ]),
  }
}
